<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col-lg-8 col-xs-12 pr-0">
        <div class="form-group mb-0 has-search">
          <span
            class="fa fa-search ml-2 mt-2 form-control-feedback color-primary"
          ></span>
          <input
            type="text"
            class="form-control no_border bg_grey"
            placeholder="Search"
            v-model="search"
            v-on:keyup.enter="searchTemplates"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <button
          class="btn btn-primary full"
          :disabled="!isSelected"
          @click="useTemplate"
        >
          USAR TEMPLATE
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div v-if="isSelected" class="ml-3 d-flex flex-column">
              <p><b>PERGUNTAS DO TEMPLATE</b></p>
              <div v-for="question in questions" :key="question.id">
                <p>{{ question.title }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <table class="table_jovool">
                  <thead class="headerTable">
                    <tr>
                      <td>
                        NOME DO TEMPLATE
                        <OrderTable field="name" entity="Template" />
                      </td>
                      <td class="center">
                        DATA DE CRIAÇÃO
                        <OrderTable
                          field="created_at"
                          entity="Template"
                          pre_order="desc"
                        />
                      </td>
                      <td class="center">
                        RECRUTADOR(A)
                        <OrderTable entity="Template" field="recruiter_name" />
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(template, index) in templates"
                      :key="template.id"
                      class="pointer full"
                      :class="
                        template_selected.id === template.id
                          ? 'selectedTr'
                          : 'selectTemplateTr'
                      "
                      @click="selectTemplate(index)"
                    >
                      <td style="border-right: none">
                        <b class="color-grey-primary">{{ template.name }}</b>
                      </td>
                      <td
                        class="center color-grey"
                        style="border-right: none; border-left: none"
                      >
                        {{ template.created_at | moment("D/MM/Y") }}
                      </td>
                      <td
                        class="center color-grey pr-4"
                        style="border-left: none"
                      >
                        {{ template.recruiter.name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import OrderTable from "components/OrderTable.vue";

export default {
  components: { OrderTable },
  data() {
    return {
      isSelected: false,
      search: "",
      questions: "",
      order: "",
      field: "",
      templates: [],
      template_selected: {},
    };
  },
  mounted() {
    eventBus.$on("orderColumnTemplate", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchTemplates();
    });
    this.searchTemplates();
  },
  methods: {
    searchTemplates() {
      let params = {};

      params["search"] = "*";
      if (this.search !== "") params["search"] = this.search;

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      } else {
        params["order"] = {};
        params["order"]["created_at"] = "desc";
      }

      axios
        .get("/recruiters/templates/search", { params: params })
        .then((response) => {
          this.templates = response.data.templates;
        });
    },
    selectTemplate(index) {
      this.isSelected = true;
      this.template_selected = this.templates[index];
      axios
        .get(`/recruiters/templates/${this.template_selected.id}/questions`)
        .then((response) => {
          this.questions = response.data.questions;
        });
    },
    useTemplate() {
      axios
        .get(`/recruiters/templates/${this.template_selected.id}/questions`)
        .then((response) => {
          let questions = response.data.questions;
          for (let index in questions) {
            questions[index].id = 0;
          }
          eventBus.$emit("updateQuestions", questions);
          this.$toast.success("Template selecionado com sucesso!");
          this.$modal.hideAll();
        });
    },
  },
};
</script>